/**
 * @enum {number}
 */
export const LogLevel = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3
};

/**
 * @class Logger
 * @description Utilitaire centralisé pour la gestion des logs
 */
class Logger {
    constructor() {
        const isDebug = typeof window !== "undefined" &&
            new URLSearchParams(window.location.search).has("debug");
        this.level = isDebug ? LogLevel.DEBUG : LogLevel.WARN;
        
        // Emojis par catégorie
        this.CATEGORIES = {
            AI: "🧠",
            ADAPTATION: "🎯",
            CORE: "⚙️",
            GAME: "🎮",
            LEVEL: "🗺️",
            AUDIO: "🔊",
            RENDER: "🖼️",
            INPUT: "⌨️",
            DEBUG: "🐞"
        };
    }

    /**
     * Définit le niveau de log minimum à afficher
     * @param {number} level 
     */
    setLogLevel(level) {
        this.level = level;
    }

    /**
     * @private
     */
    _log(level, categoryEmoji, prefix, message, ...args) {
        if (level < this.level) return;

        const logPrefix = `${categoryEmoji} [${prefix}]`;
        
        switch (level) {
            case LogLevel.DEBUG:
                console.debug(logPrefix, message, ...args);
                break;
            case LogLevel.INFO:
                console.log(logPrefix, message, ...args);
                break;
            case LogLevel.WARN:
                console.warn(logPrefix, message, ...args);
                break;
            case LogLevel.ERROR:
                console.error(logPrefix, message, ...args);
                break;
        }
    }

    debug(categoryKey, prefix, message, ...args) {
        this._log(LogLevel.DEBUG, this.CATEGORIES[categoryKey] || "📝", prefix, message, ...args);
    }

    info(categoryKey, prefix, message, ...args) {
        this._log(LogLevel.INFO, this.CATEGORIES[categoryKey] || "📝", prefix, message, ...args);
    }

    warn(categoryKey, prefix, message, ...args) {
        this._log(LogLevel.WARN, this.CATEGORIES[categoryKey] || "⚠️", prefix, message, ...args);
    }

    error(categoryKey, prefix, message, ...args) {
        this._log(LogLevel.ERROR, this.CATEGORIES[categoryKey] || "❌", prefix, message, ...args);
    }
}

export const logger = new Logger();
